import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import OmnivaSVG from '../../../images/omniva.svg';
import DpdSVG from '../../../images/dpd.svg';
import TagastusSms from '../../../images/tagastus_sms.png';
import TagastusBikini from '../../../images/tagastus_bikini.png';
import TagastusNool from '../../../images/tagastus_nool.png';
import TagastusVahetus from '../../../images/tagastus_vahetus.png';
import TagastusKuller from '../../../images/tagastus_kuller.png';
import TagastusTurvaline from '../../../images/tagastus_turvaline.png';

import './styles/index.scss';

export default function ReturnPage() {
  const shippingBoxes = () => {
    const boxes = [
      {
        image: TagastusSms,
        text: 'SMS-iga saabunud koodiga saate toote tagasi saata pakiautomaadi kaudu.',
        alt: 'Tagastus SMS',
      },
      {
        image: TagastusBikini,
        text: 'Aluspesu, ujumis- ja päevitusriietele ning sokkidele kehtib 14-päevane taganemisõigus üksnes juhul, kui toote pakend ei ole avatud.',
        alt: 'Tagastus Bikini',
      },
      {
        image: TagastusNool,
        text: 'Tooteid saab tagastada 14 päeva jooksul alates kauba kättesaamisest.\n\n(tagastamistasu 1.99 €)\n\nJalgrataste tagastamistasu on 15 €.',
        alt: 'Tagastus Nool',
      },
      {
        image: TagastusVahetus,
        text: 'Ümbervahetamine on tasuta, kuid vajalik on esitada tagastusvorm.',
        alt: 'Tagastus Vahetus',
      },
      {
        image: TagastusKuller,
        text: 'Kui toode jõudis teieni kulleriga, siis tagastage pakk postkontori või kulleri kaudu.',
        alt: 'Tagastus Kuller',
      },
      {
        image: TagastusTurvaline,
        text: 'Palume kõigi toodetega tutvuda heaperemehelikult, et need oleksid tagasi saabudes algsel kujul.',
        alt: 'Tagastus Turvaline',
      },
    ];

    return boxes.map((box) => (
      <div className="info-box" key={box.alt}>
        <div className="logo-container">
          <img className="info-box-logo" src={box.image} alt={box.alt} />
        </div>
        <p className="info-box-title">{box.text}</p>
      </div>
    ));
  };

  const returnBox = () => {
    return (
      <div className="return-box">
        <div className="return-box-title">
          Tagastusvormi leiate arve pöördelt.
        </div>
      </div>
    );
  };

  const shippingContent = () => {
    return (
      <>
        <TabPanel>
          <div className="tab-content">
            <h3>DPD pakiautomaadi tagastus</h3>
            <ul>
              <li>
                Paki saabumisel pakiautomaati saadab DPD SMS-is või e-kirja teel
                teavituse, millest leiate ka tagastuskoodi.
              </li>
              <li>
                Tagastada on võimalik enda poolt vabalt valitud DPD
                pakiautomaati.
              </li>
              <li>Sisesta vajalik kood ning aseta pakk automaati.</li>
            </ul>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tab-content">
            <h3>Omniva pakiautomaadi tagastus</h3>
            <ul>
              <li>
                Paki saabumisel pakiautomaati saadab Omniva SMS-is või e-kirja
                teel teavituse, millest leiate ka tagastuskoodi.
              </li>
              <li>
                Tagastuskoodiga saate paki tagastada samasse pakiautomaati, kust
                paki välja võtsite.
              </li>
              <li>
                Kui te mingil põhjusel tagastuskoodi ei saanud, saate paki
                tagastada ka paki triipkoodi ehk jälgimiskoodiga.
              </li>
              <li>
                Samadel tingimustel on pakki võimalik tagastada ka
                postkontorisse.
              </li>
            </ul>

            <h3>Omniva kuller tagastus</h3>
            <ul>
              <li>
                Kui olete kauba tellinud Omniva kulleriga, tuleb see ka
                kulleriga tagastada või viia postkontorisse.
              </li>
              <li>
                Omniva kulleriga tagastamiseks palume teil võtta ühendust meie
                klienditoega.
              </li>
              <li>
                Selleks, et saaksime teile kullersaadetise tagastuse vormistada,
                vajame teie:
                <ol>
                  <li>
                    täpset aadressi koos postiindeksiga, kuhu kulleri saadame.
                  </li>
                  <li>
                    kuupäeva ja 5-tunnise ajavahemiku, millal teile sobib pakk
                    kullerile üle anda.
                  </li>
                </ol>
              </li>
              <li>
                Klienditoe kontakt: <a href="tel:6154138">615 4138</a> /{' '}
                <a href="mailto:epood@rademar.ee">epood@rademar.ee</a>
              </li>
            </ul>
          </div>
        </TabPanel>
      </>
    );
  };

  return (
    <div className="component-return">
      <div className="wrap">
        <div className="boxes">
          {returnBox()}
          <div className="info">{shippingBoxes()}</div>
        </div>
        <div className="tabs">
          <Tabs className="tabs-menu">
            <TabList className="tabs-list">
              <Tab>
                <div className="border mb-5 sm:mb-0 lg:mb-5 border-solid rounded-lg">
                  <img
                    src={DpdSVG}
                    alt="DPD"
                    className="w-full h-12 my-5 px-2"
                  />
                </div>
              </Tab>
              <Tab>
                <div className="border mb-5 sm:mb-0 lg:mb-5 border-solid rounded-lg">
                  <img
                    src={OmnivaSVG}
                    alt="Omniva"
                    className="w-full h-12 my-5 px-2"
                  />
                </div>
              </Tab>
            </TabList>
            {shippingContent()}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
